//  Dependencies
import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter, Route, Switch } from "react-router-dom"

//  CSS
import "normalize.css"
import "./index.css"

//  Components
import Main from "./Main/Main"
import Form from "./form/form"
import Navbar from "./navbar/navbar"
import FullMenu from "./FullMenu/FullMenu"
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy"
import Footer from "./Footer/Footer"

//  Service Worker
import registerServiceWorker from "./registerServiceWorker"

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <div>
        <Navbar />
        <Route exact path="/" component={Main} />
        <Route path="/form" component={Form} />
        <Route path="/fullmenu" component={FullMenu} menu={["hello", "hi"]} />
        <Route path="/privacypolicy" component={PrivacyPolicy} />
        <Footer />
      </div>
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js